import { Logger } from '@aws-amplify/core';

const verbosity = process.env.NODE_ENV === 'production' ? 'ERROR' : 'DEBUG';

export const logger = new Logger('MERP', process.env.VERBOSITY || verbosity);
